"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { useState } from "react";
import { Link } from "@/navigation";
import { Plus, Minus } from "@phosphor-icons/react";

// 功能项数据接口
interface FeatureItem {
	id: string;
	iconKey: "directExpert" | "costControl" | "techCollab" | "endToEnd";
	titleKey: string;
	descriptionKey: string;
}

// 功能数据配置
const featuresData: FeatureItem[] = [
	{
		id: "directExpert",
		iconKey: "directExpert",
		titleKey: "directExpertTitle",
		descriptionKey: "directExpertDesc",
	},
	{
		id: "costControl",
		iconKey: "costControl",
		titleKey: "costControlTitle",
		descriptionKey: "costControlDesc",
	},
	{
		id: "techCollab",
		iconKey: "techCollab",
		titleKey: "techCollabTitle",
		descriptionKey: "techCollabDesc",
	},
	{
		id: "endToEnd",
		iconKey: "endToEnd",
		titleKey: "endToEndTitle",
		descriptionKey: "endToEndDesc",
	},
];

// 内联 SVG 图标组件
const DirectExpertIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 200 200" className={className} fill="currentColor">
		<path d="M65.47,78.3c0.72,1.8,2.01,3.2,3.75,4.06c0,0,0.61,0.35,1.25,0.51c0.08,0,0.1,0.08,0.14,0.08l0.04,0.04c0.04,0.04,0.08,0.1,0.08,0.18c0.18,10.57,11.5,30.37,29.24,30.37s29.1-19.84,29.24-30.37c0-0.08,0.04-0.12,0.08-0.18h0.04c0.04-0.04,0.12-0.08,0.14-0.08c0.64-0.14,1.25-0.51,1.25-0.51c1.72-0.86,3.03-2.23,3.73-4.06c1.04-2.7,1.8-8.89,2.01-10.82c0.64-6.68,0.14-10.21-1.72-12.19l-0.82-0.86l0.04-1.19c0.04-1.46,0.08-2.91,0.08-4.24c0.29-9.88,0.55-18.4-9.75-23.87l-0.98-0.51l-0.39-1.02c-3.95-9.88-16.8-10.68-21.04-10.9l-0.82-0.08c-0.55-0.08-2.09-0.08-2.09-0.08c-12.01,0.35-20.57,3.3-26.04,9.16c-7.7,8.12-7.34,19.3-7.01,29.16l0.08,3.5l-0.82,0.86c-1.8,1.93-2.3,5.61-1.66,12.11C63.63,69.02,64.34,75.49,65.47,78.3L65.47,78.3z M73.09,61.21c0.16-0.55,0.74-1.62,1.62-1.56c1.35,0.1,2.29,3.3,2.66,4.12c0.21,0.53,0.7,0.27,0.64-0.06c0,0-0.82-12.25-0.16-14.96c0.74-3.03,1.25-4.34,3.61-6.7c1.99-2.27,5.68-3.09,8.18-1.8l4.61,2.29c2.97,1.78,7.7,1.74,10.66-0.04c0,0,2.01-1.02,4.49-2.29c2.48-1.25,6.23-0.45,8.34,1.8c0,0,2.38,2.29,3.85,6.7c1.29,3.61,0.31,14.96,0.31,14.96c-0.06,0.33,0.43,0.59,0.64,0.06c0.37-0.86,1.31-4.06,2.64-4.12c0.88-0.06,1.46,1.04,1.62,1.56c0.23,0.88,0.45,2.7,0.1,6.45c-0.33,3.24-0.98,6.91-1.45,8.11c-0.31,0.74-0.86,1.25-1.66,1.5c-2.27,0.64-2.77,2.13-2.87,2.93c-0.04,0.16-0.06,0.39-0.06,0.59c-0.04,0.21-0.06,0.59-0.06,0.76c-0.31,7.64-8.98,21.6-20.84,21.6c-11.84,0-20.55-13.98-20.84-21.6c0-0.21-0.04-0.59-0.06-0.76c-0.04-0.21-0.06-0.49-0.06-0.59c-0.1-0.82-0.59-2.29-2.87-2.93c-0.8-0.21-1.35-0.74-1.66-1.5c-0.45-1.23-1.13-4.86-1.45-8.11C72.62,63.91,72.83,62.13,73.09,61.21z" />
		<path d="M130.7,122.5c7.89,3.67,15.2,5.14,20.35,6.19c2.7,0.55,6.04,1.23,7.09,1.86l0.14,0.08l0.08,0.04c0.18,0.16,1.07,1.07,2.46,3.96c1.93,4.06,3.91,10.08,5.84,17.89c2.29,9.2,3.89,18.44,4.32,21.15v0.02l0.1,0.7c0.1,0.64-0.08,1.31-0.45,1.76c-0.96,0.88-2.56,1.35-4.79,1.35H34c-3.16,0-4.32-0.9-4.61-1.21c-0.39-0.43-0.59-1.11-0.51-1.76c0.02-0.1,0.04-0.21,0.06-0.33c1.25-7.56,2.81-15.23,4.37-21.64c1.95-7.85,3.93-13.89,5.86-17.95c1.39-2.91,2.29-3.79,2.44-3.93l0.08-0.04l0.14-0.08c1.07-0.62,4.41-1.31,7.11-1.86h0.04l0.16-0.04c5.43-1.13,12.5-2.6,20.16-6.15c2.6,11.31,9.02,25.7,9.39,26.5l10.29,22.91l7.89-23.83c0.86-2.6,2.19-6.6,3.09-9.14c0.59,1.64,1.56,4.43,3.16,9.18l7.97,23.65l10.2-22.77c3.09-6.88,5.84-14.22,7.79-20.68C129.79,126.09,130.31,124.16,130.7,122.5 M126.11,109.84c-0.72,0-1.45,0.14-2.11,0.49c-1.41,0.74-2.19,2.11-2.05,3.75l0.04,0.18c0.51,3.2-3.28,16.7-9.61,30.84c-1.46-4.38-3.05-8.98-3.89-11.13c2.3-2.71,3.71-4.8,4.1-6.25c1.11-4.18-2.27-6.72-3.42-7.56c-1.04-0.74-2.32-1.15-3.59-1.15c-0.76,0-1.5,0.14-2.17,0.45l-3.05,1.27l-0.08,0.06c-0.1,0.04-0.23,0.06-0.37,0.06c-0.14,0-0.25-0.02-0.31-0.06l-3.16-1.33c-0.68-0.29-1.43-0.45-2.19-0.45c-1.27,0-2.56,0.39-3.55,1.15c-1.11,0.84-4.53,3.34-3.42,7.56c0.35,1.45,1.76,3.54,4.14,6.25c-0.82,2.13-2.38,6.78-3.81,11.13c-6.33-14.1-10.1-27.56-9.61-30.8l0.04-0.18c0.12-1.64-0.64-3.05-2.05-3.75c-0.64-0.33-1.37-0.47-2.09-0.47c-1.43,0-2.89,0.55-3.95,1.31l-0.04,0.04c-8.46,4.98-16.46,6.62-22.91,7.95c-4.28,0.86-7.66,1.56-10.1,3.01c-3.07,1.68-7.66,6.41-13.05,28.07c-2.85,11.52-4.59,22.64-4.61,22.77c-0.55,3.63,0.61,7.34,3.05,9.96c1.84,1.93,5.35,4.28,11.72,4.28h131.84c6.33,0,9.86-2.34,11.84-4.34c2.44-2.6,3.59-6.31,3.05-9.96v-0.04c0-0.1-1.72-11.19-4.61-22.77c-5.39-21.68-10.04-26.43-13.05-28.07c-2.44-1.45-5.86-2.13-10.1-3.01c-6.46-1.31-14.53-2.97-22.95-7.99C129,110.39,127.54,109.84,126.11,109.84L126.11,109.84z" />
		<path d="M89.32,63.98c1.78,0,3.42,0.98,4.26,2.56l0.41,0.76l0.04,0.61v0.08c0.02,0.33,0.04,0.61,0.04,0.86c0,2.66-2.19,4.82-4.86,4.82c-1.29,0-2.5-0.51-3.4-1.43c-0.88-0.9-1.35-2.09-1.33-3.36v-0.08C84.49,66.15,86.66,63.98,89.32,63.98 M110.7,64.02c2.7,0,4.86,2.17,4.86,4.82s-2.19,4.82-4.86,4.82c-2.66,0-4.82-2.17-4.82-4.82c0-0.2,0-0.49,0.02-0.59l0.14-0.92l0.41-0.78C107.3,65,108.93,64.02,110.7,64.02 M89.32,60.08c-4.82,0-8.73,3.91-8.73,8.73c-0.1,4.84,3.83,8.75,8.65,8.75c4.82,0,8.77-3.91,8.77-8.73c0-0.41-0.04-0.8-0.06-1.21c0.64-0.12,1.33-0.18,2.03-0.18c0.7,0,1.41,0.06,2.09,0.21c-0.06,0.39-0.06,0.8-0.06,1.17c0,4.82,3.91,8.73,8.73,8.73s8.77-3.91,8.77-8.73s-3.91-8.73-8.77-8.73h-0.02c-3.22,0-6.17,1.78-7.7,4.61c-0.98-0.23-1.99-0.35-3.03-0.35s-2.03,0.12-2.97,0.33C95.55,61.97,92.68,60.08,89.32,60.08z M143.61,131.5c-6.23,0-11.31,5.08-11.31,11.29c0,6.23,5.08,11.29,11.31,11.29s11.31-5.08,11.31-11.29C154.92,136.56,149.84,131.5,143.61,131.5z M143.61,150.06c-4.02,0-7.29-3.24-7.29-7.27c0-4.02,3.24-7.27,7.29-7.27c4.02,0,7.29,3.24,7.29,7.27C150.9,146.82,147.66,150.06,143.61,150.06z" />
		<path d="M146.74,147.58l-3.12-1.62l-3.11,1.62l0.59-3.48l-2.5-2.44l3.48-0.51l1.54-3.14l1.54,3.14l3.48,0.51l-2.5,2.44L146.74,147.58z M127.58,172.71l8.14-22.68l3.46,0.98l-5.06,14.12l8.71-4.94l1.95,2.73L127.58,172.71z" />
		<path d="M158.32,172.71l-17.21-9.79l1.95-2.71l8.71,4.94l-5.06-14.12l3.46-1L158.32,172.71z" />
	</svg>
);

const CostControlIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 200 200" className={className} fill="currentColor">
		<path d="M184.79,98.26c-9.8-10.88-23.3-17.72-37.87-19.21l-7.42-0.53l5-5.9c1.69-3.1,2.06-6.47,2.46-10.03l0.05-0.47l0.2-21.52c0-3.02-0.71-5.65-2.29-8.51l-0.04-0.06l-0.46-1.37l0.11-0.27c0.7-1.74,0.96-3.01,0.96-4.49c0-3.93-2.05-7.6-6.11-10.92c-3.84-3.14-9.38-5.9-16.46-8.22C109.8,2.46,91.88,0,73.78,0S37.76,2.46,24.61,6.76c-7.08,2.31-12.62,5.08-16.46,8.22C4.1,18.3,2.05,21.97,2.05,25.9c0,1.64,0.33,3.22,0.94,4.44l0.14,0.29l-0.46,1.4L2.63,32.1c-1.58,2.87-2.29,5.49-2.29,8.52v21.56c0,3.54,1.27,7.14,3.58,10.12l0.33,0.43l-1.29,2.17c-1.76,3.19-2.62,6.08-2.62,8.84v21.56c0,3.2,1.05,6.45,3.29,10.2l0.27,0.46l-1.31,1.76c-1.76,3.18-2.6,6.05-2.6,8.81v21.56c0,8.94,7.48,17.31,21.07,23.57c13.78,6.35,32.38,9.85,52.36,9.85c8.37,0,24.36-1.8,24.52-1.82l0.39-0.04l0.27,0.28c5.38,5.59,11.81,10.06,18.93,13.15c7.35,3.22,15.29,4.87,23.32,4.86c32.61,0,59.13-26.66,59.13-59.44C200.19,123.64,194.76,109.27,184.79,98.26L184.79,98.26z M29.06,16.41c11.95-3.66,27.95-5.68,45.06-5.68c36.59,0,62.09,9.08,62.09,17.22c0,4.01-6.21,8.22-17.04,11.54c-11.95,3.67-27.95,5.68-45.05,5.68c-36.59,0-62.09-9.08-62.09-17.22C12.03,23.94,18.24,19.73,29.06,16.41z M10.67,42.23L12,43.45c5.2,4.75,14.04,8.68,25.56,11.36c10.76,2.51,23.28,3.83,36.21,3.83s25.45-1.32,36.21-3.83c11.52-2.68,20.37-6.61,25.56-11.36l1.34-1.22v19.61c0,6.54-6.5,13.23-17.84,18.36c-12.07,5.45-28.15,8.46-45.28,8.46s-33.2-3-45.28-8.46c-11.33-5.12-17.84-11.81-17.84-18.36L10.67,42.23L10.67,42.23z M95.24,101.22l-1.07,1.46c-4.78,6.52-8.1,14-9.73,21.92c-0.1,0.59-0.22,1.2-0.35,1.84c-0.32,1.58-0.66,3.22-0.66,4.86v0.8h-0.8c-1.17,0-2.45,0.09-3.69,0.17c-1.24,0.08-2.58,0.17-3.8,0.17c-17.15,0-33.29-3-45.45-8.46c-11.45-5.13-18.01-11.82-18.01-18.36l-0.37-22.46l1.39,1.35c5.63,5.5,14.28,10.09,25,13.28c10.92,3.25,23.75,4.97,37.11,4.97c6.42,0,12.63-0.69,18.63-1.37L95.24,101.22z M92.6,168.72c-6.02,0.71-12.08,1.05-18.14,1.03c-17.34,0-33.57-2.49-45.7-7.03c-11.5-4.3-18.1-10.01-18.1-15.68v-18.42l1.29,1.03c11.77,9.39,35.72,15.23,62.5,15.23c2.71,0,5.06,0,7.73-0.34l0.76-0.1l0.12,0.76c1.03,6.19,3.05,11.85,6.03,16.83l0.03,0.05c0.9,1.81,2.12,3.44,3.94,5.27l1.16,1.17L92.6,168.72z M175.74,172.8c-9.17,9.29-21.45,14.4-34.53,14.4c-13.67,0-26.32-5.56-35.65-15.65c-2.08-2.1-3.83-4.56-5.52-6.93l-0.02-0.04c-5-7.91-7.64-17.08-7.62-26.44v-0.34c0-2.79,0.35-5.6,0.69-8.31c0.35-2.46,1.05-4.92,1.73-7.3l0.01-0.04c5.93-17.6,21.37-30.29,39.79-32.7c2.1-0.35,4.21-0.35,6.25-0.35h1.73c12.61,0.51,24.41,5.83,33.28,15c8.86,9.12,13.81,21.34,13.8,34.05C189.85,151.22,184.89,163.53,175.74,172.8z" />
		<path d="M165.31,133.75c-2.07-1.55-5.01-1.13-6.56,0.94l-10.31,13.75v-42.19c0-2.59-2.1-4.69-4.69-4.69s-4.69,2.1-4.69,4.69v42.19l-10.31-13.75c-1.55-2.07-4.49-2.49-6.56-0.94c-2.07,1.55-2.49,4.49-0.94,6.56l0,0l18.75,25c1.55,2.07,4.49,2.49,6.56,0.94c0.36-0.27,0.67-0.58,0.94-0.94l18.75-25C167.81,138.24,167.39,135.3,165.31,133.75L165.31,133.75z" />
	</svg>
);

const TechCollabIcon = ({ className }: { className?: string }) => (
	<svg
		viewBox="0 0 200 200"
		className={className}
		fill="none"
		stroke="currentColor"
		strokeWidth="10"
		strokeMiterlimit="10"
	>
		<ellipse cx="69.16" cy="100" rx="51.64" ry="46.42" />
		<ellipse cx="129.81" cy="100" rx="51.64" ry="46.42" />
	</svg>
);

const EndToEndIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 200 200" className={className} fill="currentColor">
		<path d="M150,6.25c9.66,0,17.74,7.34,18.66,16.95l0.09,1.8v53.79h-12.5V25c0-3.02-2.16-5.61-5.12-6.15l-1.12-0.1H25c-3.02,0-5.61,2.16-6.15,5.12L18.75,25v150c0,3.02,2.16,5.61,5.12,6.15l1.12,0.1h62.81l-0.05,12.5H25c-9.66,0-17.74-7.34-18.66-16.95L6.25,175V25c0-9.66,7.34-17.74,16.95-18.66L25,6.25H150z M79.74,85.05v12.5H45.21v-12.5H79.74z M131.25,46.66v12.5H45.21v-12.5L131.25,46.66z" />
		<path d="M143.75,93.75c27.61,0,50,22.39,50,50s-22.39,50-50,50s-50-22.39-50-50S116.14,93.75,143.75,93.75z M143.75,106.25c-20.71,0-37.5,16.79-37.5,37.5s16.79,37.5,37.5,37.5s37.5-16.79,37.5-37.5S164.46,106.25,143.75,106.25z M166.57,124.35l8.8,8.88l-30.91,30.65c-2.26,2.22-5.79,2.5-8.38,0.66l-0.87-0.76l-20.88-21.71l9-8.66l16.65,17.31l26.59-26.37L166.57,124.35L166.57,124.35z" />
	</svg>
);

// SVG 图标组件映射
const IconMap = {
	directExpert: DirectExpertIcon,
	costControl: CostControlIcon,
	techCollab: TechCollabIcon,
	endToEnd: EndToEndIcon,
};

// 单个折叠面板组件
function AccordionItem({
	feature,
	isOpen,
	onToggle,
	t,
}: {
	feature: FeatureItem;
	isOpen: boolean;
	onToggle: () => void;
	t: (key: string) => string;
}) {
	const IconComponent = IconMap[feature.iconKey];

	return (
		<div className="border-b-2 border-[#a0a0a0] last:border-b-0">
			{/* 标题行 */}
			<button
				onClick={onToggle}
				className="flex w-full items-center justify-between px-4 py-4 text-left transition-colors sm:px-6 sm:py-5"
				aria-expanded={isOpen}
			>
				<div className="flex items-center gap-3 sm:gap-4">
					<IconComponent className="h-8 w-8 flex-shrink-0 text-black" />
					<h3 className="text-lg font-medium text-black sm:text-xl">{t(feature.titleKey)}</h3>
				</div>
				<div className="flex h-6 w-6 items-center justify-center sm:h-7 sm:w-7">
					{isOpen ? (
						<Minus size={20} className="font-bold text-mainColor" weight="bold" />
					) : (
						<Plus size={20} className="font-bold text-mainColor" weight="bold" />
					)}
				</div>
			</button>

			{/* 展开内容 */}
			<div
				className={`overflow-hidden transition-all duration-300 ease-in-out ${
					isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
				}`}
			>
				<div className="px-6 pb-4 sm:px-6 sm:pb-5">
					{/* 描述 */}
					<p className="text-sm leading-relaxed text-gray-600 sm:text-base">{t(feature.descriptionKey)}</p>
				</div>
			</div>
		</div>
	);
}

export default function SmartFactory() {
	const t = useTranslations("smartFactory");
	const [openId, setOpenId] = useState<string>("directExpert");
	const [isVideoPlaying, setIsVideoPlaying] = useState(false);

	const handleToggle = (id: string) => {
		setOpenId(openId === id ? "" : id);
	};

	return (
		<section className="pb-12">
			<div className="container">
				{/* 标题区域 */}
				<div className="mx-auto mb-8 text-center sm:mb-10 md:mb-12 lg:mb-16">
					<h2 className="text-2xl font-bold text-black sm:mb-5 sm:text-3xl md:mb-6 md:text-4xl lg:text-[42px] lg:leading-tight">
						{t("title")}
					</h2>
				</div>

				{/* 内容区域 */}
				<div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-12 xl:gap-16">
					{/* 左侧折叠面板 */}
					<div className="w-full lg:w-1/2">
						<div className="overflow-hidden rounded-xl border-2 border-[#8c8c8c] bg-white shadow-sm">
							{featuresData.map((feature) => (
								<AccordionItem
									key={feature.id}
									feature={feature}
									isOpen={openId === feature.id}
									onToggle={() => handleToggle(feature.id)}
									t={t}
								/>
							))}
						</div>
					</div>

					{/* 右侧视频 */}
					<div className="w-full lg:sticky lg:top-24 lg:w-1/2">
						<div className="relative aspect-[4/2.8] overflow-hidden rounded-xl">
							{isVideoPlaying ? (
								<iframe
									width="100%"
									height="100%"
									src="https://www.youtube.com/embed/SY98L7GL870?si=Ih52MQ61HeIG-qy4&autoplay=1"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									referrerPolicy="strict-origin-when-cross-origin"
									allowFullScreen
									className="absolute inset-0 h-full w-full"
								></iframe>
							) : (
								<div
									className="relative h-full w-full cursor-pointer"
									onClick={() => setIsVideoPlaying(true)}
								>
									<Image
										src="/image/new-version/home/smart-factories.webp"
										alt={t("title")}
										fill
										className="object-cover"
										sizes="(max-width: 1024px) 100vw, 50vw"
										priority
									/>
									{/* 视频播放按钮 */}
									<div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20">
										<button className="rounded-full bg-black bg-opacity-75 p-3 text-white transition-transform hover:scale-110 focus:outline-none">
											<svg className="h-12 w-12" fill="currentColor" viewBox="0 0 24 24">
												<path d="M8 5v14l11-7z" />
											</svg>
										</button>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>

				{/* 底部按钮 */}
				<div className="mt-8 text-center sm:mt-10 md:mt-12">
					<Link
						href="/upload"
						className="group inline-flex w-full items-center justify-center gap-2 rounded bg-themePrimary400 px-4 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white sm:w-fit sm:px-5 sm:py-3 md:px-10 md:py-3.5 md:text-base"
					>
						{t("ctaButton")}
					</Link>
				</div>
			</div>
		</section>
	);
}
